import { getDisplayTime } from "../utils/General";

/**
 * Template for display
 * @param {*} fields
 */
export function CurrentEvent({
    sensor_id,
    sensor_name,
    sensor_type,
    room_id,
    room_name,
    status,
    message,
    update_time,
    alert_time,
    check_in_time,
}) {
    this.sensorId = sensor_id;
    this.sensorName = sensor_name;
    this.sensorType = sensor_type;
    this.roomId = room_id;
    this.roomName = room_name;
    this.status = status;
    this.message = message;
    this.updateTime = update_time;
    this.alertTime = alert_time;
    this.checkInTime = check_in_time;
}

const colorConverter = {
    Normal: "#38bf8b",
    Alert: "#ffca3a",
    Offline: "#ff595e",
};

export const currEventCol = ["Sensor", "Type", "Room", "Message", "Last Update", "Alert Time", "Check In Time"];

/**
 * Convert a CurrentEvent object to displayable JSON
 * @param {*} res Response body from api calls
 * @returns serialized CurrentEvent object
 */
export function parseCurrentEventDisplay(res) {
    let sensorNameDisplay = res.sensorName ? res.sensorName : "--";
    let sensorTypeDisplay = res.sensorType ? res.sensorType : "--";
    let roomNameDisplay = res.roomName ? res.roomName : "--";

    let checkInTimeDisplay = res.checkInTime ? getDisplayTime(res.checkInTime) : "--";
    let obj = new CurrentEvent({
        sensor_name: sensorNameDisplay,
        sensor_type: sensorTypeDisplay,
        room_name: roomNameDisplay,
        message: res.message === "Very Smelly" ? "Ammonia level High" : res.message,
        update_time: getDisplayTime(res.updateTime),
        alert_time: getDisplayTime(res.alertTime),
        check_in_time: checkInTimeDisplay,
    });
    return JSON.parse(JSON.stringify(obj));
}
